function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.98 6.938h-.359v10.125h.359V6.938zm-.745 1.125h-.36v7.875h.36V8.063zm-1.116 0H0v7.875h16.119V8.063zm7.881 0h-4.508v7.875H24V8.063zm-5.256 0h-.36v7.875h.36V8.063z"
});

function SvgStitcher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+U3RpdGNoZXIgaWNvbjwvdGl0bGU+PHBhdGggZD0iTTE3Ljk4IDYuOTM4aC0uMzU5djEwLjEyNWguMzU5VjYuOTM4em0tLjc0NSAxLjEyNWgtLjM2djcuODc1aC4zNlY4LjA2M3ptLTEuMTE2IDBIMHY3Ljg3NWgxNi4xMTlWOC4wNjN6bTcuODgxIDBoLTQuNTA4djcuODc1SDI0VjguMDYzem0tNS4yNTYgMGgtLjM2djcuODc1aC4zNlY4LjA2M3oiLz48L3N2Zz4=";
export { SvgStitcher as ReactComponent };